import * as stateMachine from 'rwwa-rx-state-machine'

export const close = stateMachine.createIntent('CLOSE MODAL')
